import { render } from "./AddStockOpname.vue?vue&type=template&id=1ec6915d"
import script from "./AddStockOpname.vue?vue&type=script&lang=js"
export * from "./AddStockOpname.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__